import React, { useState } from 'react';

import styled from 'styled-components';

import { createCompany } from 'apis/UserAPI';
import { useRootContext } from 'components/layout/RootContext';
import Button from 'components/lib/Button';

import CompaniesCreateEditModal from './CompaniesCreateEditModal';
import { mapRequest } from './utils';
import { useCompaniesContext } from '../CompaniesContext';
import { CompanyListItemType } from '../table/types';

const PlusButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CompaniesCreateButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { showMessage } = useRootContext();

  const { refetch } = useCompaniesContext();

  const getErrorMessage = (errorResponse: any) => {
    const candidate =
      errorResponse?.primary_user_id ??
      errorResponse?.p_c_email ??
      errorResponse?.non_field_errors ??
      errorResponse?.detail;

    if (Array.isArray(candidate) && candidate.length > 0) {
      return candidate[0];
    }

    if (typeof candidate === 'string') {
      return candidate;
    }

    return 'Failed to create company';
  };

  const onCreate = async (company: CompanyListItemType) => {
    const payload = mapRequest(company);

    try {
      await createCompany(payload);
      showMessage('success', 'Company created successfully');
      refetch();
    } catch (reason: any) {
      const errorResponse = reason?.response?.data;
      showMessage('error', getErrorMessage(errorResponse));
      console.error(reason);
      throw reason;
    }
  };

  return (
    <div>
      <PlusButton type={'primary'} onClick={() => setOpen(true)}>
        <img src="/icons/add.svg" height="24px" width="24px" alt="add" />
        <span>Add Company</span>
      </PlusButton>
      <CompaniesCreateEditModal
        open={open}
        handleClose={() => setOpen(false)}
        onSubmit={onCreate}
        title="Add Company"
      />
    </div>
  );
};

export default CompaniesCreateButton;
